// MFR Form Constants
export const  MFR_TAG = "MFR";
export const ACTUALS_LABEL = 'Actuals';
export const ACTUALS_VALUE = 'actuals';
export const USD_CONSTANT_LABEL = 'USD Constant';
export const USD_CONSTANT_VALUE = 'usd-constant';
export const MILLIONS_VALUE = 'millions';
